import { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    Grid2 as Grid,
    Tooltip,
} from '@mui/material';
import { AccountCircle, Add, Cancel, Check, CleanHands, ClearAll, CloudDone, Delete, Download, Edit, Info, Message, PlayArrow, QrCode } from '@mui/icons-material';
import { getMyDate, getSelectedElement, myTimestampToDate, propComparator } from "../utils/ui_utils";

import { format } from "date-fns";
import { EventDialog } from "../modals/EventDialog";
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { get_Event_list } from "../FirebaseUtils/dbEvent";
import { TemplateCategorySection } from "../components/TemplateCategorySection";
import { TemplateAwardSection } from "../components/TemplateAwardSection";
import { TemplateMatch_completeSection } from "../components/TemplateMatchCompleteSection";
import { TemplateMatchConfigSection } from "../components/TemplateMatchConfigSection";

const section_list = [
    { id: 'category_template', label: 'Template Categorie' },
    { id: 'award_template', label: 'Template Premi' },
    { id: 'award_label_template', label: 'Template Etichette Premi' },
    { id: 'match_config_template', label: 'Template configurazione gara' },
    { id: 'match_complete_template', label: 'Template Gare' },
]

export default function SetupPage() {
    const dialogRef = useRef()
    const dialogParsingRef = useRef()
    const dialogQRRef = useRef()

    const childRefDelete = useRef()
    const [element_list, setElementList] = useState([])
    const [cur_session, setCurrentSession] = useState()
    const [cur_section, setCurSection] = useState('category_template')

    const reloadFn = async () => {
        const data = await get_Event_list()
        setElementList(data.sort(propComparator('title')))
    }


    useEffect(() => {
        reloadFn()

    }, [])


    useEffect(() => {
        if (element_list.length > 0) {
        }

    }, [element_list])


    useEffect(() => {
        console.log("AFTER SET", cur_session)

    }, [cur_session])

    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>

            <DeleteconfirmationSection ref={childRefDelete} />
            <EventDialog ref={dialogRef} reloadFn={reloadFn} />
            <Card sx={{ border: '1px solid lightblue', mt: 1 }}>
                <CardContent>
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={"grow"} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                            Setup Sistema
                        </Grid>
                        <Grid size={"auto"}>
                            <ButtonGroup>

                                {section_list.map((s, k) => (
                                    <Button key={k} variant={cur_section === s.id ? 'contained' : 'outlined'} onClick={() => setCurSection(s.id)}>{s.label}</Button>
                                ))}

                            </ButtonGroup>
                        </Grid>
                    </Grid>

                    <Grid >
                        {cur_section ==='category_template' &&
                        <TemplateCategorySection />
                        }
                        {cur_section ==='award_template' &&
                        <TemplateAwardSection />
                        }
                        {cur_section ==='award_label_template' &&
                        <></>
                        }
                        {cur_section ==='match_config_template' &&
                        <TemplateMatchConfigSection />
                        }
                        {cur_section ==='match_complete_template' &&
                        <TemplateMatch_completeSection />
                        }
                    </Grid>
                </CardContent>
            </Card>
        </Box >
    );
}



